export enum ResultsType {
    products = 'products',
    workers = 'workers',
    merchants = 'merchants',
    services = 'services',
    orders = 'orders',
    promotions = 'promotions',
    pointsServices = 'pointsServices',
}
